.Svg {
  display: block;
}
